import { useEffect, useState } from 'react';

export interface ChallengeTimerProps {
  /**
   * Timestamp in seconds
   */
  expiresOn: number;
  onExpire?(): void;
}

function getTimeleft(expiresOn: number) {
  return Math.max(0, expiresOn - Math.floor(Date.now() / 1000));
}

export const useChallengeTimer = ({ expiresOn, onExpire }: ChallengeTimerProps) => {
  const [timeleft, setTimeleft] = useState(getTimeleft(expiresOn));
  const [expired, setExpired] = useState(!timeleft);

  useEffect(() => {
    const interval = setInterval(() => {
      const newTimeleft = getTimeleft(expiresOn);

      setTimeleft(newTimeleft);

      if (!newTimeleft) {
        clearInterval(interval);
        setExpired(true);
        onExpire?.();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [expiresOn, onExpire]);

  return { expired, timeleft };
};
